export enum QRCodeIntegrationType {
    Simple = 'simple',
    Noodoe = 'noodoe',
}

export interface QRCodeIntegration {
    type: QRCodeIntegrationType,
    strip_prefix: string,
    append_prefix?: string
}